import NoDataComponent from '@Components/General/Feedback/no-data-component';
import { AddCircleOutlineRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const NoTemplates = () => {
    const { t } = useTranslation();

    return (
        <NoDataComponent
            primary={t('prompts:noData.emailTemplates.noData.primary')}
            secondary={t('prompts:noData.emailTemplates.noData.secondary')}
            Icon="dashboard"
            action={
                <Button
                    startIcon={<AddCircleOutlineRounded />}
                    color="primary"
                    LinkComponent={Link}
                    to="new"
                >
                    {t('Create Template')}
                </Button>
            }
        />
    );
};

export default NoTemplates;
